// @ts-expect-error pure js
import useResource from "./use-resource.js";
import type { MailTemplateMeta } from "../models/mailTemplate";

interface UseMailTemplatesCatalog {
  catalog: MailTemplateMeta[] | null;
  error: unknown;
  isLoading: boolean;
}

export default function useMailTemplatesCatalog(): UseMailTemplatesCatalog {
  const {
    resource: catalog,
    error,
    isLoading,
  } = useResource("/mail-templates/catalog");

  return {
    catalog,
    error,
    isLoading,
  };
}
